// src/CcpAdminUsers/EditForm/EditModal.js
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  CircularProgress,
} from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../../config/firebase";

const EditModal = ({ open, onClose, user, onSuccess }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [ccpAdminFlag, setCcpAdminFlag] = useState(false);
  const [techPrepAdminFlag, setTechPrepAdminFlag] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setPhone(user.phone);
      setCcpAdminFlag(user.ccpAdminFlag === true);
      setTechPrepAdminFlag(user.techPrepAdminFlag === true);
    }
  }, [user]);

  const handleSubmit = async () => {
    setLoading(true);
    const userRef = doc(db, "users", user.id);
    await updateDoc(userRef, {
      name,
      email,
      phone,
      ccpAdminFlag,
      techPrepAdminFlag,
    });
    setLoading(false);
    onSuccess();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Edit User</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Name"
          type="text"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Email"
          type="email"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Phone"
          type="text"
          fullWidth
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={ccpAdminFlag}
              onChange={(e) => setCcpAdminFlag(e.target.checked)}
            />
          }
          label="CCP Admin"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={techPrepAdminFlag}
              onChange={(e) => setTechPrepAdminFlag(e.target.checked)}
            />
          }
          label="Tech Prep Admin"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditModal;
